import { useEffect, useRef, useState, useTransition } from 'react';

import { loadErrors } from '~modules/journal/api';
import { JournalDto } from '~modules/journal/model';

export function useErrorsList() {
	const [list, setList] = useState<JournalDto[]>([]);
	const [pending, startLoading] = useTransition();
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			startLoading(async () => {
				const data = await loadErrors();
				setList(data);
			});
		}
	}, []);

	return { pending, list };
}
